/* eslint-disable @typescript-eslint/no-unused-expressions */
import { DbLoaderHttp, RhybusError } from '@rhybus/api'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
//import { extractTextFromFileBuffer } from '../../assets/ts/pii/pii'
import { ExcelDropAreaResult } from '../../components/excel-drop-area/excel-drop-area.types'
import { FileOperation } from './generate.types'
import GenerateSection from './generate-section'
import { apiPath, fetchProvider } from '../../api/api'
import RolesInit from './roles-init'
import { UserContext } from '../contexts/UserContextProvider'
import { RhyBusAlert } from '@rhybus/alert'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
import { RhyBusPageHeader } from '@rhybus/header'
import { CreateESGRolesFromExcel } from '../roles/roles-config'

async function handleFile(file: File, operation: FileOperation) {
  const dbLoader = new DbLoaderHttp(fetchProvider, apiPath)

  const formData = new FormData()
  formData.append('file', file)

  const result: ExcelDropAreaResult = {
    isError: false,
    message: '',
  }
  let apiResponse: string | unknown
  if (operation === 'loadRoles') {
    apiResponse = await CreateESGRolesFromExcel(file)
    // const rawRoles: any = await extractTextFromFileBuffer(file, 'xlsx')
    // const formattedRoles = constructRolesArray(rawRoles)
    // formattedRoles ? await rolesConfig.CreateCPTSRoles(formattedRoles) : ''
    // if (formattedRoles.length > 0) {
    //   result.message = 'User Groups, Roles and Permission have successfully been Initialized'
    // } else {
    //   result.message = 'User Groups, Roles and Permission Failled to Initialize'
    // }
  } else {
    try {
      const apiResponse =
        operation === 'createIndexes'
          ? await dbLoader.createIndexes(formData)
          : operation === 'createLists'
            ? await dbLoader.addorupdatelists(formData)
            : operation === 'createViews'
              ? await dbLoader.addorupdateviews(formData)
              : operation === 'loadLists'
                ? await dbLoader.loadLists(formData)
                : `Unexpected server operation: ${operation}`

      result.message = JSON.stringify(apiResponse)
    } catch (ex) {
      console.error('Exception', ex)
      result.isError = true

      if (ex instanceof RhybusError) {
        result.message = `${ex.name}: ${ex.message}`
      } else {
        result.message = `An unkown error occurred:  ${JSON.stringify(ex)}`
      }
    }
  }

  return result
}

const Generate = () => {
  const _navigate = useNavigate()
  // const { userRoles,isUserDetailsLoading,me } = useContext(UserContext)
  // useEffect(()=>{
  //   if (!isUserDetailsLoading && !(userRoles.isSiteAdmin || userRoles.isTRMSuperAdmin)) {
  //     navigate('/accessdenied')
  //   }
  // },[isUserDetailsLoading,userRoles])
  const { me: _me } = useContext(UserContext)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [successMsg, setSuccessMsg] = useState<string>('')
  const [isLoading, _setIsLoading] = useState<boolean>(false)

  return (
    <>
      {isLoading && <PageOverlay />}
      <RhyBusAlert
        show={!!successMsg}
        variant="success"
        message={successMsg}
        icon="icon-rb-checked font-16 me-2"
        className="alert-success"
        onClose={() => setSuccessMsg('')}
      />
      <RhyBusAlert
        show={!!alertMsg}
        variant="info"
        message={alertMsg}
        className="alert-info font-12"
        confirmLabel="Ok"
        okIcon="icon-rb-checked font-11 pe-1"
        cancelIcon="icon-rb-close font-10 pe-1"
        onConfirm={() => setAlertMsg('')}
        onClose={() => setAlertMsg('')}
      />

      <div className='divcontainer generate-height'>
        <RhyBusPageHeader pageTitle='App Config' />
        <GenerateSection
          dropAreaTitle='Drop List to create lists/tables'
          processFileHandler={(file) => handleFile(file, 'createLists')}
          sectionTitle='▤ Create Lists'
        />

        <GenerateSection
          dropAreaTitle='Drop Index Creation File Here'
          processFileHandler={(file) => handleFile(file, 'createIndexes')}
          sectionTitle='▤ Create Indexes'
        />

        <GenerateSection
          dropAreaTitle='Drop File to Load list/tables Here'
          processFileHandler={(file) => handleFile(file, 'loadLists')}
          sectionTitle='▤ Load Lists'
        />
        <GenerateSection
          dropAreaTitle='Drop View Creation  File Here'
          processFileHandler={(file) => handleFile(file, 'createViews')}
          sectionTitle='▤ Create Views'
        />
        <GenerateSection
          dropAreaTitle='Drop User Groups and Permission File Here'
          processFileHandler={(file) => handleFile(file, 'loadRoles')}
          sectionTitle='▤ Initialize Roles'
        />
        {/* <RolesInit /> */}
      </div>

    </>
  )
}

export default Generate
